<template>
  <div>
    <div class="mt-8 ml-auto flex justify-between gap-4 items-center">
      <div class="w-1/3">
        <el-input v-model="search" placeholder="Enter..." />
      </div>

      <div>
        <el-select v-model="value" placeholder="Select" class="">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
      header-row-class-name="thead-light table-th-color"
    >
      <el-table-column
        :index="indexmethod"
        type="index"
        label="Sr.no"
        width="80"
      ></el-table-column>
      <el-table-column
        v-if="userData.campaignName == 'Email'"
        label="Email Id"
        min-width="50px"
      >
        <template v-slot="{ row }">
          <P class="text-gray">{{ row }}</P>
        </template>
      </el-table-column>
      <el-table-column
        v-if="userData.campaignName == 'SMS'"
        label="Phone No."
        min-width="50px"
      >
        <template v-slot="{ row }">
          <P class="text-gray">{{ row }}</P>
        </template>
      </el-table-column>
      <el-table-column
        v-if="userData.campaignName == 'Whats App'"
        label="Phone No."
        min-width="50px"
      >
        <template v-slot="{ row }">
          <P class="text-gray">{{ row }}</P>
        </template>
      </el-table-column>
      <el-table-column label="Date" min-width="50px">
        <template>
          <div class="flex gap-2 flex-wrap">
            <el-tag class="text-gray rounded-full" type="success">{{
              userData.campaign.createdAt.split("T")[0]
            }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Status" min-width="50px">
        <template>
          <P class="text-gray">{{ status }}</P>
        </template>
      </el-table-column>

      <!-- <el-table-column label="Sub Category" min-width="50px">
        <template v-slot="{ row }">
          <div class="flex gap-2 flex-wrap" v-if="row.subcategoryId.length">
            <el-tag
              v-for="(i, index) in row.subcategoryId"
              :key="index"
              class="text-gray rounded-full"
              type="success"
              >{{ i.name }}</el-tag
            >
          </div>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      background
      @current-change="
        (value) => {
          currentPage = value;
          assignData();
        }
      "
      layout="prev,pager,next"
      :page-size="5"
      :total="pageCount"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage: 1,
      tableData: [],
      pageCount: 0,
      value: "Delivered",
      status: "",
      search: "",
      options: [
        {
          label: "Delivered",
          value: "Delivered",
        },
        {
          label: "Bounced",
          value: "Bounced",
        },
      ],
    };
  },
  props: {
    userData: {
      type: Object,
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.assignData();
      }
    },
    search(val) {
      if (val != "") {
        this.search();
      } else {
        this.assignData();
      }
    },
  },
  methods: {
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 5;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    search() {
      this.tableData = this.userData.campaign.totalDelivered.includes(
        this.search
      );
    },
    assignData() {
      if (this.value == "Delivered") {
        this.pageCount = this.userData.campaign.totalDelivered.length;
        let end = this.currentPage * 5;
        let start = end - 5;
        this.tableData = this.userData.campaign.totalDelivered.slice(
          start,
          end
        );
        this.status = this.value;
      }
      if (this.value == "Bounced") {
        if (this.userData.campaign.totalBounced.length > 5) {
          let end = this.currentPage * 5;
          let start = end - 5;
          this.tableData = this.userData.campaign.totalBounced.slice(
            start,
            end
          );
          this.status = this.value;
          this.pageCount = this.userData.campaign.totalBounced.length;
        } else {
          this.tableData = this.userData.campaign.totalBounced;
          this.status = this.value;
          this.pageCount = this.userData.campaign.totalBounced.length;
        }
      }
    },
  },
  mounted() {
    // console.log("user€data", this.userData);
    this.assignData();
  },
};
</script>
